export const cleanObjectFromUndefinedValues = (input: object) => {
  return Object.keys(input).reduce(
    (prev, curr) =>
      input[curr as keyof typeof input]
        ? {
            ...prev,
            [curr]: input[curr as keyof typeof input],
          }
        : { ...prev },
    {}
  );
};
